import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
    value?: string | null;
    format?: string; // allow custom format
}

const FormatLocalDate: React.FC<Props> = ({
    value,
    format = "DD-MM-YYYY hh:mm A", // Default format
}) => {
    if (!value) return <span>-</span>;

    // Convert UTC → local time (user’s browser timezone)
    const localDate = dayjs.utc(value).tz(dayjs.tz.guess());

    return <span>{localDate.format(format)}</span>;
};

export default FormatLocalDate;
